import { useState } from "react";

// Shared expand/collapse section — extracted from B2BDashboard.js so guide
// pages and any future collapsible content reuse the same look/behavior.
export default function Collapsible({ title, defaultOpen = false, className = "quote-box", style, children }) {
  const [open, setOpen] = useState(defaultOpen);
  return (
    <div className={className} style={{ marginTop: "12px", padding: 0, overflow: "hidden", ...style }}>
      <button
        type="button"
        className="secondary"
        onClick={() => setOpen(o => !o)}
        style={{ width: "100%", margin: 0, borderRadius: 0, border: "none", display: "flex", justifyContent: "space-between", alignItems: "center", padding: "12px 16px" }}
      >
        <span style={{ fontWeight: 600 }}>{title}</span>
        <span>{open ? "▲" : "▼"}</span>
      </button>
      {open && <div style={{ padding: "0 16px 16px" }}>{children}</div>}
    </div>
  );
}
